<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="alert-subHeader">
    <div class="signedOff-alerts">
        <p-checkbox name="signedOffAlerts" [tabindex]='tabLevel' label="{{configData.alertLabel.alertCheckBoxText}}" [(ngModel)]='showSignedOff' [binary]="true" (onChange)='handleSingedOffAlerts($event);'></p-checkbox>
    </div>
    <div class="subHeader-buttons">
        <button type="button" tabindex="{{tabLevel + 1}}" class="p-button-secondary" [ngClass]="{'p-button-disabled': (dirSignOffAlerts && dirSignOffAlerts.length === 0) && (deskSignOffAlerts && deskSignOffAlerts.length === 0)}" (click)="cancelOperationForAlerts();">
          {{configData.alertLabel.cancelBtn}}
        </button>
        <button type="button" tabindex="{{tabLevel + 2}}" class="p-button-primary ml-3" [ngClass]="{'p-button-disabled': (dirSignOffAlerts && dirSignOffAlerts.length === 0) && (deskSignOffAlerts && deskSignOffAlerts.length === 0)}" (click)="submitOperationForAlerts();">
          {{configData.alertLabel.submitBtn}}
        </button>
    </div>
</div>